// extracted by mini-css-extract-plugin
module.exports =  {"promoWrap":"promoWrap___156ZS","title":"title___gfBSd","promoBlock":"promoBlock___sAQ8S"};